{
  "title": "Dojo betreten 🥷",
  "startLabelingButton": "Los geht's mit dem Labeln 🚀"
}
